module.exports = __webpack_public_path__ + "static/media/Verve.99415ee5.svg";